module.exports = __webpack_public_path__ + "static/media/Abi Bayer_headshot 2020_1595272552963.bf9ae005.JPG";